import { GlobalData } from "@/app/global_data"
import { findChart } from "@/app/types"
import {
  MenuItem,
  getNavigationMenuOptions,
} from "@/components/sidebar_menu/sidebar_menu.options_definition"
import { useRouter } from "next/router"

export function useSidebarNavigation(globalData: GlobalData) {
  const { pathname, push } = useRouter()
  const isChartsPage = pathname.startsWith("/charts")

  function handleNavigationClick(url: string, chartCode?: string) {
    if (chartCode && globalData.isLoaded()) {
      const chart = findChart(chartCode)
      if (!isChartsPage) push(url)

      globalData.setChart(chart).notify()
    } else {
      push(url)
    }
  }

  function getActiveItems(pathname: string) {
    const menu = getNavigationMenuOptions()

    const activeChartCode = globalData.isLoaded() && globalData.getChart().code

    // if its charts page, and we have an active and valid chart code
    if (isChartsPage && activeChartCode) {
      for (const item of menu) {
        if (item.children) {
          for (const child of item.children) {
            if (child.chartCode === activeChartCode) {
              return { activeItem: child, parentItem: item }
            }
          }
        }
      }
    }

    for (const item of menu) {
      if (item.url === pathname) {
        return { activeItem: item, parentItem: null }
      }

      if (item.children) {
        const bestMatch = item.children.reduce<{
          item: unknown | null
          score: number
        }>(
          (acc, child) => {
            if (
              pathname === child.url ||
              pathname?.startsWith(child.url + "/") ||
              pathname === child.url + "/"
            ) {
              const score = child.url.length
              if (score > acc.score) {
                return { item: child, score }
              }
            }
            return acc
          },
          { item: null, score: -1 }
        )

        if (bestMatch.item) {
          return { activeItem: bestMatch.item as MenuItem, parentItem: item }
        }
      }
    }

    return { activeItem: null, parentItem: null }
  }

  return { handleNavigationClick, getActiveItems, isChartsPage, globalData }
}
